export function scrollTo (selector:string, duration:number = 300, offset = 300):HTMLTextAreaElement|HTMLInputElement {
    let elem:HTMLTextAreaElement|HTMLInputElement = document.querySelector(selector);

    if (elem) {
        let box = elem.getBoundingClientRect();
        let body = document.body;
        let docEl = document.documentElement;
    
        let scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        let clientTop = docEl.clientTop || body.clientTop || 0;
        let elemTop = box.top + scrollTop - clientTop;
    
        let diff = elemTop - scrollTop - offset;
        let start;
    
        // Bootstrap our animation - it will get called right before next frame shall be rendered.
        window.requestAnimationFrame(function step(timestamp) {
            if (!start) start = timestamp;
            // Elapsed miliseconds since start of scrolling.
            let time = timestamp - start;
            // Get percent of completion in range [0, 1].
            let percent = Math.min(time / duration, 1);
        
            window.scrollTo(0, scrollTop + diff * percent);
        
            // Proceed with animation as long as we wanted it to.
            if (time < duration) {
                window.requestAnimationFrame(step);
            }
        });
    }


    return elem;
}
  